import * as queryString from 'query-string';
import React, { useState } from "react";
import { IPage } from '../../global/state-helpers/page';
import { PaginatedLandingContent } from '../components/paginated-landing-content-app';
import PageContext from '../context/pageContext';
import { IPaginatedLandingContent, LayoutStyle, PillColor } from '../models/paginated-landing-content';

export default function App() {
    const paginatedElements = (window as any).bootstrap.PaginatedElements as IPaginatedLandingContent[];
    const paginatedFilters = (window as any).bootstrap.Filters;
    const pageSize = (window as any).bootstrap.PageSize;
    const fallbackImageUrl = (window as any).bootstrap.FallbackImageUrl;
    const showFallbackImage = (window as any).bootstrap.ShowFallbackImage;
    const layoutStyle = ((window as any).bootstrap.LayoutStyle || LayoutStyle.List) as LayoutStyle;
    const topicPillColor = ((window as any).bootstrap.TopicPillColor || PillColor.BlueT1) as PillColor;
    const rolePillColor = ((window as any).bootstrap.RolePillColor || PillColor.GreenT1) as PillColor;
    const ageRangePillColor = ((window as any).bootstrap.AgeRangePillColor || PillColor.YellowT1) as PillColor;
    const contentTypePillColor = ((window as any).bootstrap.ContentTypePillColor || PillColor.BlueVioletT1) as PillColor;
    const specialtyPillColor = ((window as any).bootstrap.SpecialtyPillColor || PillColor.RedT1) as PillColor;
    const rawParams = queryString.parse(window.location.search, { parseNumbers: true })
    let pageModel = { page: rawParams.page ? +rawParams.page : 1, pageSize: pageSize } as IPage;
    let searchText = rawParams.q && rawParams.q.toString();
    const [topicFilter, setTopicFilter] = useState([]);
    const [roleFilter, setRoleFilter] = useState([]);
    const [ageFilter, setAgeFilter] = useState([]);
    const [contentTypeFilter, setContentTypeFilter] = useState([]);
    const [specialtyFilter, setSpecialtyFilter] = useState([]);
    const [activeFilter, setActiveFilter] = useState(false);
    const [filtersData, setFiltersData] = useState(paginatedFilters);

    const updateTopicFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.topicFilters
        filterChanged[filterIndex].value = newCount;
        setFiltersData({ ...filtersData, topicFilters: [...filterChanged] });
    }

    const updateRoleFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.roleFilters
        filterChanged[filterIndex].value = newCount;
        setFiltersData({ ...filtersData, roleFilters: [ ...filterChanged ] });
    }

    const updateAgeFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.ageRangesFilters
        filterChanged[filterIndex].value = newCount;
        setFiltersData({ ...filtersData, ageRangesFilters: [...filterChanged] });
    }

    const updateContentTypeFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.contentTypeFilters
        filterChanged[filterIndex].value = newCount;
        setFiltersData({ ...filtersData, contentTypeFilters: [...filterChanged] });
    }

    const updateSpecialtyFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.specialtyFilters
        filterChanged[filterIndex].value = newCount;
        setFiltersData({ ...filtersData, specialtyFilters: [...filterChanged] });
    }

    return (
        <PageContext.Provider value={{
            topicFilter: topicFilter,
            setTopicFilter: setTopicFilter,
            roleFilter: roleFilter,
            ageFilter: ageFilter,
            setAgeFilter: setAgeFilter,
            setRoleFilter: setRoleFilter,
            contentTypeFilter: contentTypeFilter,
            setContentTypeFilter: setContentTypeFilter,
            specialtyFilter: specialtyFilter,
            setSpecialtyFilter: setSpecialtyFilter,
            activeFilter: activeFilter,
            setActiveFilter: setActiveFilter,
        }}>

            <PaginatedLandingContent
                items={paginatedElements}
                layoutStyle={layoutStyle}
                pageModel={pageModel}
                searchText={searchText}
                filtersData={filtersData}
                fallbackImageUrl={fallbackImageUrl}
                showFallbackImage={showFallbackImage}
                topicFilter={topicFilter}
                roleFilter={roleFilter}
                ageFilter={ageFilter}
                contentTypeFilter={contentTypeFilter}
                specialtyFilter={specialtyFilter}
                activeFilter={activeFilter}
                updateTopicFilterCount={updateTopicFilterCount}
                updateRoleFilterCount={updateRoleFilterCount}
                updateAgeFilterCount={updateAgeFilterCount}
                topicPillColor={topicPillColor}
                rolePillColor={rolePillColor}
                ageRangePillColor={ageRangePillColor}
                contentTypePillColor={contentTypePillColor}
                specialtyPillColor={specialtyPillColor}
                updateContentTypeFilterCount={updateContentTypeFilterCount}
                updateSpecialtyFilterCount={updateSpecialtyFilterCount}
            />
        </PageContext.Provider>
    );
}


